export const ConsultPrivileges = {
    proyTconsultPrivileges: 'CONSULT_PROYT',
    suscriberConsultPrivilege: 'CONSULT_SUBSCRIBER',
    checkerConusltPrivilege: 'CONSULT_ECD',
    consultElectronic:'CONSULT_ELECTRONIC',
    managementChecker: "MANAGEMENT_CHECKER",
    myselfConusltPrivilege: 'CONSULT_MYSELF',
    downloadMyself: 'DOWNLOAD_MYSELF',
    downloadConstancy: 'DOWNLOAD_CONSTANCY',
    rejectProcess: "REJECT_ECD",
    downloadECD: "DOWNLOAD_ECD",
    consultRole: "ROLE_CONSULT",
    createRole: "ROLE_CREATE",
    editRole: "ROLE_EDIT",
    revokeECD: "REVOKE_ECD",
    credentialsECD: "CREDENTIALS_ECD",
    revokeMyself: "REVOKE_MYSELF",
    consultUser: "USER_CONSULT",
    editUser : "USER_EDIT",
    createUser: "USER_CREATE",
    consultConfig: "CONSULT_CONFIG",
    modifyConfig: "MODIFY_CONFIG",
    locationList: "LOCATION_CONSULT",
    createLocation  : "LOCATION_CREATE",
    editLocation: "LOCATION_EDIT",
    otherProductsConsult: "OTHCERTIFICATE_CONSULT",
    otherProductsResend: "OTHCERTIFICATE_RESEND",
    otherProductsDecision : "OTHCERTIFICATE_DECISION",
    otherProductsApproved: "OTHCERTIFICATE_APPROVE",
    otherProductsRejected: "OTHCERTIFICATE_REJECT",
    requestManagerValidate: "OTHCERTIFICATE_VALIDATE",
    logisticRoutes: "LOGISTIC_CONSULT",
    generateGuide : "LOGISTIC_GUIDE",
    generateManifest: "LOGISTIC_MANIFEST",
    printSobreflex: "PRINT_SOBREFLEX",
    downloadGuide: "LOGISTIC_DOWNLOAD",
    cancelManifest: "LOGISTIC_CANCEL",
    confirmDelivery: "DELIVERY_CONFIRM",
    supervisorConsult: "CONSULT_SUP",
    assignRequestShow: "ASSIGN_REQUEST",
    updateLocation: "UPDATE_LOCATION",
    resendQueue: "RESEND_QUEUE",
    assignSupervisor: "ASSIGN_SUPERVISOR",
    documentaryValidationReadOnly: "DOCVAL_READONLY",
    listRequest: "CONSULT_REQUEST",
    veriCredentialsECD: "SIGNATURE_ECD",
    suscriberConsultSupPrivilege: 'CONSULTSUP_SUBSCRIBER',
    forwardNotification: "FORWARD_NOTIF"
};

export const insuanceMyself = "ISSUANCE_MYSELF";
export const reviewMyself = "REVIEW_MYSELF";

export const insuanceProyT = "ISSUANCE_PROYT";
export const reviewProyT = "REVIEW_PROYT";
export const downloadProyT = "DOWNLOAD_PROYT";
export const revokeProyT = "REVOKE_PROYT";
export const rejectedProyT = "REJECTED_PROYT";

export const insuanceSubscriber = "ISSUANCE_SUBSCRIBER";
export const consultSubscriber = "CONSULT_SUBSCRIBER";
export const revokeSubscriber = "REVOKE_SUBSCRIBER";
export const filloutSubscriber = "FILLOUT_SUBSCRIBER";
export const validateIdentitySubscriber = "VALIDATEIDENTITY_SUBSCRIBER";
export const remedyIdentityCF = "REMEDY_IDENTITYCF";
export const remedyIdentityAn = "REMEDY_IDENTITYAN";

export const blackListRoles = [
    { role: 'MYSELFCERT LICSUP' }
]
